import moment from "moment/moment";
import { HighchartsChartDataType } from "@/storybook/c8r-highcharts/common/utils/types/common";
import { Budget } from "@/services/cloudchipr.api";
import { getPlannedBudgetsMap } from "@/components/pages/common/billing-explorer/utils/getPlannedBudgetsMap";

export const getPlannedBudgetChartSeries = (
  chartData: HighchartsChartDataType,
  budget: Budget,
  labels: Record<string, string> | null,
) => {
  const plannedMap = getPlannedBudgetsMap(
    budget.start_date,
    budget.period,
    budget.planned_amounts,
  );

  return chartData.categories.map((dateName) => {
    const date = labels?.[dateName] ?? dateName;

    const dateAsNumber =
      budget.period === "monthly"
        ? moment(date).month()
        : moment(date).quarter();

    return { y: plannedMap?.[dateAsNumber] ?? 0 };
  });
};
